// src/components/SideBar/NavigationMenu.jsx

import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
} from "@mui/material";
import { Icons } from "../../config/MuiIcons.config";
import { SIDEBAR_MENU_CONFIG } from "./SidebarMenu.config";
import { useNavigate } from "react-router-dom";
import { removeEntity } from "../../common/CommonFunctions";

const NavigationMenu = ({
  label,
  icon,
  path,
  children,
  open,
  onClick,
  selected,
  showNested = true,
  isNested = false,
  ...rest
}) => {

  const { nav_icon, nav_item } = SIDEBAR_MENU_CONFIG;

  const navigate = useNavigate();

  const handleClick = () => {
    if (children && showNested) {
      onClick && onClick();
    } else if (path) {
      removeEntity(process.env.REACT_APP_ENTITY_DETAILS);
      navigate(path);
    }
  };

  return (
    <>
      <ListItemButton
        onClick={handleClick}
        selected={selected}
        sx={{
          mb: nav_item.marginBottom,
          borderRadius: nav_item.borderRadius,
          bgcolor: selected ? nav_item.highlightBg : "inherit",
          color: selected ? nav_item.highlightColor : isNested ? nav_item.nestedEleColor : "inherit",
          "&.Mui-selected": {
            bgcolor: nav_item.highlightBg,
            color: nav_item.highlightColor,
          },
          "&:hover": {
            bgcolor: nav_item.hoverBg,
          },
          "&.Mui-selected:hover": {
            bgcolor: nav_item.highlightBg, // Keep selected color on hover
            color: nav_item.highlightColor,
          },
          ml: isNested ? nav_item.paddingLeftNested : 0,
        }}
        {...rest}
      >
        <ListItemIcon
          sx={{
            color: selected ? nav_icon.active : nav_icon.default,
            minWidth: nav_icon.minWidth,
            fontSize: nav_icon.size,
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={label}
          slotProps={{
            primary: {
              fontWeight: selected || !isNested
                ? nav_item.fontWeightActive
                : nav_item.fontWeight,
              fontSize: nav_item.fontSize,
            },
          }}
        />
        {children &&
          showNested &&
          (open ? <Icons.ExpandLessIcon /> : <Icons.ExpandMoreIcon />)}
      </ListItemButton>
      {children && showNested && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default NavigationMenu;